import { showNotification } from '@/utils/notificationHelper';

import codeMessage from './codeMessage';

const successHandler = (response, options = { notifyOnSuccess: false, notifyOnFailed: true }) => {
  const { data, status } = response;
  const isSuccessStatus = status >= 200 && status < 300;
  const isDataSuccess = data && data.success === true;

  // We consider it a success if the HTTP status is in the 2xx range, 
  // OR if the data explicitly says success is true.
  if (isSuccessStatus || isDataSuccess) {
    const message = data && data.message;
    const successText = message || codeMessage[status];

    if (options.notifyOnSuccess) {
      showNotification.success({
        message: `Request success`,
        description: successText,
      });
    }
  } else {
    const message = data && data.message;
    const errorText = message || codeMessage[status];
    if (options.notifyOnFailed) {
      showNotification.error({
        message: `Request error ${status}`,
        description: errorText,
      });
    }
  }
};

export default successHandler;
